import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'lv',
    fullName: 'Latvian',
    nativeName: 'Latviešu',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Tuvojas kaut kas pārsteidzošs",
    landing_subtitle: "ArgVoid ir lietotņu un spēļu izstrādes studija. Sekojiet līdzi jaunumiem, drīzumā būs jaunas lietas!",
    select_language: "Izvēlieties valodu",
    search_placeholder: "Meklēt valodas...",
    terms_title: "Pakalpojuma noteikumi",
    policy_title: "Privātuma politika",
    cookies_title: "Sīkdatņu politika",
    terms_content: `
        <strong>1. Noteikumu pieņemšana</strong><br>
        Piekļūstot ArgVoid, tiek pieņemti šie pakalpojumu sniegšanas noteikumi. Ja šie noteikumi netiek pieņemti, pakalpojumu nevajadzētu izmantot.<br><br>

        <strong>2. Platformas lietošana</strong><br>
        ArgVoid un tā lietojumprogrammas tiek nodrošinātas "tādas, kādas ir" informatīviem un radošiem nolūkiem. Pakalpojums ir jāizmanto tikai likumīgiem mērķiem.<br>X<br>

        <strong>3. Aizliegta rīcība</strong><br>
        Vietnes ievainojamību izmantošana, surogātpasta sūtīšana vai nesankcionētas piekļuves mēģinājums infrastruktūrai ir stingri aizliegts.<br><br>

        <strong>4. Atruna</strong><br>
        Platforma un pakalpojumi var tikt mainīti jebkurā laikā bez brīdinājuma. Garantija par pakalpojuma darbības laiku vai pieejamību netiek sniegta.
    `,
    policy_content: `
        <strong>1. Informācijas kolekcija</strong><br>
        Pašlaik platformai nav nepieciešama lietotāja autentifikācija vai konta izveide. No apmeklētājiem netiek aktīvi vākta personas identificējoša informācija (piemēram, vārdi vai e-pasta adreses).<br><br>

        <strong>2. Lietošanas dati</strong><br>
        Lai izprastu vietnes trafiku un uzlabotu lietojumprogrammas, var tikt apkopota anonimizēta pamata analīze. Šie dati nav saistīti ar atsevišķu lietotāju identitātēm.<br>X<br>

        <strong>3. Trešās puses pakalpojumi</strong><br>
        Trešo pušu pakalpojumu sniedzēji var tikt izmantoti mitināšanas un analīzes pakalpojumiem. Šo attiecīgo pakalpojumu sniedzēju privātuma prakse regulē anonīmos datus, kas tiek apstrādāti viņu infrastruktūrā.<br><br>

        <strong>4. Datu drošība</strong><br>
        Lai aizsargātu platformu, tiek īstenoti saprātīgi drošības pasākumi. Tomēr neviena pārraides metode internetā nav pilnībā droša.<br><br>
    `,
    cookies_content: `
        <strong>1. Kas ir sīkfaili un vietējā krātuve?</strong><br>
        Sīkfaili un pārlūkprogrammas lokālā krātuve ir nelieli datu faili, kas tiek glabāti ierīcē, lai atcerētos konfigurācijas preferences apmeklējumu laikā.<br><br>

        <strong>2. Lietošanas mērķis</strong><br>
        Pārlūka LocalStorage tiek izmantota tikai, lai saglabātu konfigurācijas iestatījumus, piemēram: <br>
        - Valodas preferences<br>
        - Lietotāja saskarnes konfigurācija (piem., izkārtojuma vai motīva iestatījumi) <br>
        - Pagaidu lietojumprogrammas kešatmiņa<br><br>

        <strong>3. Nav Tracking</strong><br>
        Sīkfaili un vietējā krātuve netiek izmantoti reklāmas vai trešo pušu izsekošanas nolūkos. Visi saglabātie dati ir paredzēti tikai platformas pamatfunkcionalitātei.<br><br>

        <strong>4. Control</strong><br>
        Pārlūka datus var notīrīt jebkurā laikā, izmantojot pārlūkprogrammas iestatījumus, kas atiestatīs visas vietējās konfigurācijas.
    `,
    cookie_consent_text: "Mēs izmantojam pamata sīkfailus, lai nodrošinātu vietnes pareizu darbību, piemēram, uzturētu jūsu sesiju aktīvu, saglabātu jūsu valodas preferences un citas pielāgotas konfigurācijas.",
    read_policy: "Izlasiet sīkfailu politiku",
    support_title: "Sazinieties ar atbalsta dienestu",
    support_subject_label: "Priekšmets",
    support_message_label: "Ziņa",
    support_submit_button: "Nosūtīt ziņu",
    support_hint: "Piezīme. Tiks atvērta noklusējuma e-pasta programma, lai nosūtītu ziņojumu.",
    support_success_msg: "Notiek jūsu e-pasta lietotnes atvēršana...",
    support_error_msg: "Neizdevās nosūtīt ziņojumu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    explorer_title: "Explorer",
    history_title: "Vēsture",
    animation_title: "Animācija",
    config_title: "Konfigurācija",
    tool_mouse: "Atlasīt (Ctrl+M)",
    tool_brush: "Ota (Ctrl+B)",
    tool_brush_mode: "Pārslēgt režīmu (nemainīgs/dzirs)",
    tool_eraser: "Dzēšgumija (Ctrl+E)",
    tool_brush_size: "Pielāgojiet otas izmēru",
    tool_bucket: "Aizpildīt (Ctrl+F)",
    tool_eyedropper: "Pilinātājs",
    tool_grid: "Režģis (Ctrl+Shift+B)",
    tool_rotate: "Pagriezt (Ctrl+Shift+R)",
    tool_flip_h: "Apgriezt H (Ctrl+Shift+H)",
    tool_flip_v: "Apgriezt V (Ctrl+Shift+V)",
    tool_transpose: "Transponēt (Ctrl+Shift+T)",
    label_width: "Platums",
    label_height: "Augstums",
    label_frames: "Kadru skaits",
    label_animation: "Animācijas stils",
    label_background_color: "Fona krāsa",
    label_interval: "Intervāls",
    tool_anim_config: "Animācijas konfigurācija",
    label_new_width: "Jauns platums",
    label_new_height: "Jauns augstums",
    label_apply: "Pieteikties",
    label_colors: "Krāsas",
    label_size: "Izmērs",
    label_tolerance: "Tolerance",
    val_horizontal: "Horizontāli",
    val_vertical: "Vertikāli",
    val_sequence: "Secība",
    val_bounce: "Atlēciens",
    val_random: "Nejauši",
    val_solid: "Ciets",
    val_clear: "Skaidrs",
    action_add_sheet: "Jauna lapa",
    action_import: "Importēt",
    action_export: "Eksportēt",
    action_sort_projects: "Kārtot",
    sort_date_old: "Vecākais pirmais",
    sort_date_new: "Jaunākie vispirms",
    sort_name_az: "Vārds (A-Z)",
    sort_name_za: "Vārds (Z-A)",
    action_new_sprite: "Jauns Sprite",
    action_new_project: "Jauns Projekts",
    modal_save_all_title: "Saglabāt visas izmaiņas",
    modal_save_all_desc: "Atlasiet saglabājamos līdzekļus:",
    modal_save_selected: "Saglabāt atlasītos",
    action_saved: "Saglabāts",
    modal_create_sprite_title: "Izveidojiet jaunu Sprite",
    modal_create_project_title: "Izveidot jaunu projektu",
    modal_add_sheet_title: "Pievienot jaunu lapu",
    modal_rename_sheet_title: "Pārdēvēt lapu",
    modal_rename_sprite_title: "Pārdēvējiet Sprite",
    modal_delete_sprite_title: "Dzēst Sprite",
    modal_delete_project_title: "Dzēst projektu",
    modal_delete_sheet_title: "Dzēst lapu",
    placeholder_sprite_name: "Vārds",
    placeholder_project_name: "Vārds",
    placeholder_sheet_name: "Vārds",
    placeholder_new_name: "Jauns Vārds",
    action_create: "Izveidot",
    action_add: "Pievienot",
    action_rename: "Pārdēvēt",
    action_duplicate: "Dublikāts",
    action_delete: "Dzēst",
    action_cancel: "Atcelt",
    confirm_delete_sprite: "Vai tiešām vēlaties dzēst šo spraitu?",
    confirm_delete_project: "Vai tiešām vēlaties dzēst šo projektu? Visi spraiti tiks noņemti.",
    confirm_delete_sheet: "Vai tiešām vēlaties dzēst šo lapu?",
    err_select_sprite: "Lūdzu, vispirms atlasiet spraitu.",
    err_select_project: "Lūdzu, vispirms atlasiet projektu.",
    err_name_empty: "Vārda lauks nedrīkst būt tukšs.",
    err_sprite_exists: "Spraite ar šādu nosaukumu jau pastāv.",
    err_project_exists: "Projekts ar šādu nosaukumu jau pastāv.",
    err_no_content: "Nav satura, ko saglabāt.",
    err_no_changes: "Nav saglabājamu izmaiņu.",
    err_delete_last_sheet: "Nevar izdzēst pēdējo lapu.",
    err_extract_frames: "Nevarēja izvilkt nevienu kadru.",
    err_indexeddb: "Neizdevās saglabāt lokāli. Jūsu pārlūkprogramma var neatbalstīt IndexedDB.",
    msg_upload_success: "Augšupielāde sekmīga: {0}",
    msg_upload_failed: "Augšupielāde neizdevās: {0}",
    msg_save_success: "Saglabāt veiksmīgi.",
    msg_saving: "Notiek saglabāšana...",
    msg_multi_save_result: "Saglabāti {0} līdzekļi. {1} kļūmes.",
    menu_title: "Izvēlne",
    menu_save: "Saglabāt",
    menu_save_all: "Saglabāt visu",
    menu_support: "Sazinieties ar atbalsta dienestu",
    label_local_storage: "Vietējā krātuve",
    label_sign_in: "Pierakstīties",
    modal_export_title: "Eksportēt Sprite",
    label_filename: "Faila nosaukums",
    label_format: "Formāts",
    action_export_confirm: "Eksportēt",
};

export default translations;
